import { HttpClient } from '@adapters/HttpClient';
import { Filters } from '../models/Filters';
import { RefundOrder, RefundsApiResponse } from '../models/RefundOrder';

export interface RefundsPage {
  orders: RefundOrder[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class RefundsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getRefundsPaginated(filters: Filters = {}): Promise<RefundsPage> {
    const { ref, shop_id, status, date_from, date_to, page = 1, per_page = 25, sortBy, sortDirection } = filters;

    const params: Record<string, any> = {
      page,
      per_page,
    };

    if (ref && ref.trim()) params.ref = ref.trim();
    if (shop_id !== undefined && shop_id !== null) params.shop_id = shop_id;
    if (status) params.status = status;
    if (date_from) params.date_from = date_from;
    if (date_to) params.date_to = date_to;
    if (sortBy) params['sorting[column]'] = sortBy;
    if (sortDirection) params['sorting[direction]'] = sortDirection;

    const showGlobalLoading = page === 1;
    const response = await this.httpClient.get<RefundsApiResponse>(
      '/cod-payments/delivered-orders-liquidation',
      params,
      {},
      showGlobalLoading,
    );

    return {
      orders: response.data,
      nextPage: response.meta.currentPage < response.meta.lastPage ? response.meta.currentPage + 1 : undefined,
      hasMore: response.meta.currentPage < response.meta.lastPage,
      total: response.meta.total,
    };
  }
}
